import React from 'react';

import {UserStatusMarker} from 'src/components/user-status-marker';

import {EllipsisTextHint} from '@pb/kit-component-ellipsis-text-hint';

import {formatPlatformValue} from './platform-columns';

type Props = {type: string, status: string, statusCode: string, showStatusMarker?: boolean};

export const PlatformCell = ({type, status, statusCode, showStatusMarker = true}: Props) => (
    <EllipsisTextHint title={formatPlatformValue(type, status)}>
        {showStatusMarker ? <UserStatusMarker statusCode={statusCode}/> : null}
        <strong>{type}</strong>: {status}
    </EllipsisTextHint>
);
